import { render, staticRenderFns } from "./scene2.vue?vue&type=template&id=03e9076d&"
import script from "./scene2.vue?vue&type=script&lang=js&"
export * from "./scene2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports